// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import AsyncComponent from 'customer-data-ui-utilities/component/AsyncComponent';
import { AsyncComponentErrorHandler } from '../../helpers/AsyncComponentErrorHandler';
import { jsx as _jsx } from "react/jsx-runtime";
function requirement(done) {
  import( /* webpackChunkName: "PartnerSharedActivitiesContainer" */'partner-shared-messages-lib/PartnerSharedActivitiesContainer').then(mod => mod.default).then(done, AsyncComponentErrorHandler('partner-shared-activities'));
}
export default function PartnerSharedActivitiesContainerAsync(props) {
  return /*#__PURE__*/_jsx(AsyncComponent, {
    props: props,
    requirement: requirement
  });
}